import { useContext } from "react"
import VisibilityContext from "src/provider/state-manager/visibilityProvider"
import { AppLabel, AppText, Button, CustomContainer, FlexRow, GridContainer } from "src/style"
import { DisplayBox } from "src/popup"
import {ReactComponent as ConfirmIcon} from 'src/assets/img/confirm.svg'


export const CallScheduleSummary: React.FC<any> = ({close}) => {
    const {responder} = useContext(VisibilityContext)
    function handleConfirm () {
        responder.show(
            'Call confirmed', 
            'Your call to James has been scheduled', 
            <ConfirmIcon/>, 
            'Continue',
            null
        )
        close()
    }

    return (
        <DisplayBox close={close}>
            <GridContainer width='70' sizeUnit='%' style={{margin: '0 auto'}}>
                <AppLabel textSize='2' fontWeight='600' color='#27272E'>Call to Ridwan</AppLabel>
                <AppText topMargin='1'>See scheduled call information below</AppText>
                <FlexRow 
                    justifyContent='space-between' gap='1' topMargin='3' 
                    width='75' sizeUnit='%'
                >
                    <CustomContainer width='auto' sizeUnit=''>
                        <AppLabel textSize='1.2' color='#718096'>Reason for call</AppLabel>
                        <AppText textSize='1.2' color='#101225'>Password reset</AppText>
                    </CustomContainer>
                    <CustomContainer width='auto' sizeUnit=''>
                        <AppLabel textSize='1.2' color='#718096'>Agent in-charge</AppLabel>
                        <AppText textSize='1.2' color='#101225'>Ridwan Kolawole</AppText>
                    </CustomContainer>
                </FlexRow>
                <FlexRow 
                    justifyContent='space-between' gap='1.5' topMargin='2'
                    width='75' sizeUnit='%'
                >
                    <CustomContainer width='auto' sizeUnit=''>
                        <AppLabel textSize='1.2' color='#718096'>Date</AppLabel>
                        <AppText textSize='1.2' color='#101225'>14th November, 2022</AppText>
                    </CustomContainer>
                    <CustomContainer width='auto' sizeUnit=''>
                        <AppLabel textSize='1.2' color='#718096'>Time</AppLabel>
                        <AppText textSize='1.2' color='#101225'>2:30pm - 3:00om</AppText>
                    </CustomContainer>
                </FlexRow>
                <Button
                    width='13' borderColor='#4C6FFF' height='4.6'
                    hoverBgColor='#ffffff' hoverColor='#4C6FFF'
                    radius="0.8" topMargin='6'
                    onClick={handleConfirm}
                >
                    Confirm call
                </Button>
            </GridContainer>
        </DisplayBox>
    )
}